<div class="login-form-container">
  <div class="container-fluid">
    <div class="row login-form">
      <div class="col-md-5">
        <div id="login" class="form-container">
          <div id="login-row" class="justify-content-center align-items-center">
            <div id="login-box">
              <div id="login-column" class="login-column-c">
                <p class="text-center login-title">{{'userLogin.changePassword.Title' | translate}}</p>
                <br><br>
                <form [formGroup]="changePassword" novalidate>
                  <label for="oldPassword" class="text-info">{{'userLogin.changePassword.oldPassword' | translate}}<span class="error">*</span></label><br>
                  <input type="password" class="form-control" formControlName="oldPassword" required [ngClass]="{ 'is-invalid': submitted && f.oldPassword.errors }">
                  <div *ngIf="f.oldPassword.invalid && (f.oldPassword.dirty || f.oldPassword.touched)">
                    <div class="alert alert-danger" *ngIf="f.oldPassword.errors.required">{{'userLogin.changePassword.errorNewPwd1' | translate}}</div>
                  </div>
                  <label for="newPassword" class="text-info">{{'userLogin.changePassword.newPassword' | translate}}<span class="error">*</span></label><br>
                  <input type="password" class="form-control" formControlName="newPassword" required
                    [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }">
                  <div *ngIf="f.newPassword.invalid && (f.newPassword.dirty || f.newPassword.touched)">
                    <div class="alert alert-danger" *ngIf="f.newPassword.errors.required">{{'userLogin.changePassword.errorNewPwd1' | translate}}</div>
                    <div class="alert alert-danger" *ngIf="f.newPassword.errors.minlength ||
                      f.newPassword.errors.maxlength ||
                      f.newPassword.errors.pattern">
                      {{'userLogin.changePassword.errorNewPwd2' | translate}}
                    </div>
                  </div>

                  <label for="confirmPassword" class="text-info">{{'userLogin.changePassword.confirmPassword' | translate}}<span class="error">*</span></label><br>
                  <input type="password" class="form-control" formControlName="confirmPassword" required
                    [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }">
                  <div *ngIf="f.confirmPassword.invalid && (f.confirmPassword.dirty || f.confirmPassword.touched)">
                    <div class="alert alert-danger" *ngIf="f.confirmPassword.errors.required">{{'userLogin.changePassword.errorConPwd1' | translate}}</div>
                    <div class="alert alert-danger" *ngIf="f.confirmPassword.errors.minlength ||
                      f.confirmPassword.errors.maxlength ||
                      f.confirmPassword.errors.pattern">
                      {{'userLogin.changePassword.errorConPwd2' | translate}}
                    </div>
                  </div>

                  <div class="captcha-group">
                    <div class="captcha">
                      <img [src]="CaptchaImgUrl" alt="captcha-image" class="captcha-image img-fluid">
                        <div class="refresh-icon"  matTooltip="{{'userLogin.changePassword.toolTip' | translate}}">
                          <mat-icon (click)="resendCaptcha()">refresh</mat-icon>
                        </div>
                    </div>
                    <div class="captcha-input">
                      <label for="captcha" class="text-info">{{'userLogin.changePassword.captchaLabel' | translate}}<span class="error">*</span></label><br>
                      <input type="text" class="form-control" formControlName="captchaText" [ngClass]="{ 'is-invalid': submitted && f.captchaText.errors }">
                      <div *ngIf="f.captchaText.invalid && (f.captchaText.dirty || f.captchaText.touched)">
                        <div class="alert alert-danger" *ngIf="f.captchaText.errors.required">{{'userLogin.changePassword.errorCaptcha' | translate}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="button-wrapper">
                      <button mat-flat-button class="btn-cancel btn-secondary" [disabled]="!changePassword.valid" (click)="cancel()">{{'userLogin.changePassword.cancel' | translate}}</button>
                      <button mat-flat-button class="btn-submit btn-primary" (click)="submit()" [disabled]="!changePassword.valid">
                        {{'userLogin.changePassword.submit' | translate}}</button>
                    </div>
                  </div>
                </form>
              </div>
              <span *ngIf="isDisplayError == true">{{ loginErrorMessage }}</span>
              <span *ngIf="isDisplayError == false" class="error-message invalid-feedback">{{ loginErrorMessage }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-7"></div>
    </div>
  </div>
</div>

<div class="footer-copyrights" id="cp">
  <!-- © {{fullyear}} SimpliAssess, All Rights Reserved. -->
  © {{fullyear}} {{'footer.text' | translate}}
</div>
